var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-option",class:{ selected: _vm.isSelected },on:{"click":_vm.optionClick}},[_c('span',{staticClass:"title"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }